import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox } from '../../../../../shared';
import BaseSection from './BaseSection';

const CompactDutySection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  return (
    <>
      <BaseSection hasSourceCostCenter={true} />
      <ControlledCheckbox
        control={control}
        name="not_ready_for_realisation_flag"
        label={t('notReadyForRealisation')}
      />
      <ControlledCheckbox
        control={control}
        name="dub_trv_flag"
        label={t('onlyDouble')}
      />
    </>
  );
};

export default CompactDutySection;
